<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="serialNumber"
      [isRequired]="true"
      [label]="'case.fields.serialNumber.label' | translate"
      [helpText]="'case.fields.serialNumber.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="productFamily"
      [label]="'case.fields.productFamily.label' | translate"
      [helpText]="'case.fields.productFamily.help'"
      [isRequired]="true"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownType,
        entry1: form.get('productFamily')?.value || ''
      }"
      [entry]="entry1"
      (onSelectEvent)="onSelectProductFields($event, dropdownTypeEnum.PRODUCT_GROUP)"
      (onClearEvent)="resetProductFields(dropdownTypeEnum.PRODUCT_GROUP, null)"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="productGroup"
      [isRequired]="true"
      [label]="'case.fields.productGroup.label' | translate"
      [helpText]="'case.fields.productGroup.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="productGroupItems"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownType,
        entry1: form.get('productFamily')?.value || '',
        entry2: form.get('productGroup')?.value || '',
      }"
      [entry]="entry2"
      (onSelectEvent)="onSelectProductFields($event, dropdownTypeEnum.PRODUCT_SUB_GROUP)"
      (onClearEvent)="resetProductFields(dropdownTypeEnum.PRODUCT_SUB_GROUP, null)"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="productSubGroup"
      [isRequired]="true"
      [label]="'case.fields.productSubGroup.label' | translate"
      [helpText]="'case.fields.productSubGroup.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="productSubGroupItems"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownType,
        entry1: form.get('productFamily')?.value || '',
        entry2: form.get('productGroup')?.value || '',
        entry3: form.get('productSubGroup')?.value || '',
      }"
      [entry]="entry3"
      (onSelectEvent)="onSelectProductSubGroupField($event)"
      (onClearEvent)="resetProductFields('', null)"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="productComponentVarient"
      [label]="'case.fields.productComponentVarient.label' | translate"
      [helpText]="'case.fields.productComponentVarient.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="productCode"
      [label]="'case.fields.productCode.label' | translate"
      [helpText]="'case.fields.productCode.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="materialNumber"
      [label]="'case.fields.materialNumber.label' | translate"
      [helpText]="'case.fields.materialNumber.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="softwareVersion"
      [label]="'case.fields.softwareVersion.label' | translate"
      [helpText]="'case.fields.softwareVersion.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="additonalProductInfo"
      [label]="'case.fields.additonalProductInfo.label' | translate"
      [helpText]="'case.fields.additonalProductInfo.help'"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="runTime"
      [label]="'case.fields.runTime.label' | translate"
      [helpText]="'case.fields.runTime.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-datepicker-form-field
      formControlName="installDate"
      [label]="'case.fields.installDate.label' | translate"
      [helpText]="'case.fields.installDate.help'"
      [viewMode]="viewMode"
      [maxDate]="datepickerMaxDate"
  ></app-datepicker-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="equipmentStatus"
      [label]="'case.fields.equipmentStatus.label' | translate"
      [helpText]="'case.fields.equipmentStatus.help'"
      [isRequired]="true"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownEquipmentStatusType,
        entry1: form.get('equipmentStatus')?.value || ''
      }"
      [entry]="'entry1'"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="parsReference"
      [label]="'case.fields.parsReference.label' | translate"
      [helpText]="'case.fields.parsReference.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="rmaId"
      [label]="'case.fields.rmaId.label' | translate"
      [helpText]="'case.fields.rmaId.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-checkbox-form-field
      formControlName="warranty"
      [label]="'case.fields.warranty.label' | translate"
      [helpText]="'case.fields.warranty.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <app-checkbox-form-field
      formControlName="goodwill"
      [label]="'case.fields.goodwill.label' | translate"
      [helpText]="'case.fields.goodwill.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-checkbox-form-field
      formControlName="faRequested"
      [label]="'case.fields.faRequested.label' | translate"
      [helpText]="'case.fields.faRequested.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-checkbox-form-field
      formControlName="foi"
      [label]="'case.fields.foi.label' | translate"
      [helpText]="'case.fields.foi.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-checkbox-form-field
      formControlName="doa"
      [label]="'case.fields.doa.label' | translate"
      [helpText]="'case.fields.doa.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <app-checkbox-form-field
      formControlName="ktUsed"
      [label]="'case.fields.ktUsed.label' | translate"
      [helpText]="'case.fields.ktUsed.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-checkbox-form-field
      formControlName="partsRequested"
      [label]="'case.fields.partsRequested.label' | translate"
      [helpText]="'case.fields.partsRequested.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="!viewMode">
    <!-- Blank field -->
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <app-input-form-field
      formControlName="orderNumber"
      [label]="'case.fields.orderNumber.label' | translate"
      [helpText]="'case.fields.orderNumber.help'"
      [viewMode]="viewMode"
      [translatable]="false"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="partNumber"
      [label]="'case.fields.partNumber.label' | translate"
      [helpText]="'case.fields.partNumber.help'"
      [translatable]="false"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <app-input-form-field
      formControlName="trackingNumber"
      [label]="'case.fields.trackingNumber.label' | translate"
      [helpText]="'case.fields.trackingNumber.help'"
      [viewMode]="viewMode"
      [translatable]="false"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="partsAdditonalInfo"
      [label]="'case.fields.partsAdditonalInfo.label' | translate"
      [helpText]="'case.fields.partsAdditonalInfo.help'"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <app-checkbox-form-field
      formControlName="partsArrived"
      [label]="'label.partsArrived' | translate"
      [helpText]="'case.fields.partsArrived.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
</div>
